import React, { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Routers from "../../routers/Routers";
import { useDispatch, useSelector } from "react-redux";
import LoginPopUp from "./LoginPopUp";
import {
  setCustomerInitiatedServices,
  setLoginPopUp,
} from "../../redux/slices/settingSlice";
import "./Layout.css";
import { FaArrowUp } from "react-icons/fa";
import { fetchMyservices } from "../../redux/slices/bwvSlice";
import ProgressBar from "../../utils/UtilProgress";
import { toast } from "react-toastify";
import {
  setDonationFrom,
  setDonationStatus,
} from "../../redux/slices/DonationSlice";
import SelectGurdwaraModal from "../../components/Header/SelectGurdwaraModal";
import DonateModal from "../../components/Header/modals/DonateModal";
import {
  fetchHeaderCountsThunk,
  fetchSidebarCountsThunk,
} from "../../redux/slices/userSlice";

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const isIpad = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /iPad/.test(userAgent) ||
    (navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 1 &&
      window.innerWidth > 767 &&
      window.innerWidth < 1200)
  );
};

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { loginPopUp } = useSelector((state) => state.setting);
  const { donationStatus, donationFrom } = useSelector(
    (state) => state.gurdwaraDonation
  );
  const [open, setOpen] = useState(0);
  const [hasDisplayedPopup, setHasDisplayedPopup] = useState(false);
  const isFetching = useRef(false);
  const isAdmin = user && user.Role === "admin";
  const isSignUp =
    location.pathname === "/login" || location.pathname === "/signup";
  const isPrivacyPolicy = location.pathname.includes("privacypolicies");
  const isAboutUs = location.pathname.includes("aboutus");
  const isContactUs = location.pathname.includes("contact/us");
  const isInvoicePage = location.pathname.includes("invoicePayment");
  const isResetPassword = location.pathname.includes("reset-password");
  const isGurdwara = location.pathname.startsWith("/all-products");
  const isBookGurdwara = location.pathname.includes("bookGurdwara");
  const isPostAd = location.pathname === "/needs-requests/request";
  const isPostAd2 = location.pathname === "/create-need/request";
  const isNeedCreate = isPostAd || isPostAd2;
  const isEnlargeImageView = location.pathname.includes("/enlargeImageView");
  const { myServices2, currentPage } = useSelector((state) => state.bwvData);
  const [isOpen, setIsOpen] = useState(() => {
    const screenWidth = window.innerWidth;
    const isHomePage =
      (location.pathname === "/" && location.hash === "") ||
      location.hash === "#/home";
    const iPadView = isIpad() || (screenWidth > 767 && screenWidth < 1200);
    return !(isHomePage && iPadView);
  });
  const [modal, setModal] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [gurdwaraId, setGurdwaraId] = useState(null);
  const [gurdwaraName, setGurdwaraName] = useState("");

  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );

  const handleDonate = (e) => {
    e.stopPropagation();
    if (!isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    setModalIsOpen(true);
    dispatch(setDonationFrom("LANDINGPAGE"));
  };

  const toggleGurdwaraModal = (e) => {
    e.stopPropagation();
    if (!islogin) {
      toast.info("Please login to book a Gurdwara.");
      return;
    }
    if (!isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    setGurdwaraId(null);
    setGurdwaraName("");
    setModal(true);
  };

  const handleViewAds = (e) => {
    e.stopPropagation();
    navigate("/Localcommunityads");
  };

  useEffect(() => {
    if (user?.UserID) {
      const userId = user.UserID;
      const roleType = user?.Role !== "admin" ? user.Role : "";

      dispatch(
        fetchHeaderCountsThunk({
          userId,
          ...(roleType && { roleType }),
        })
      );

      dispatch(
        fetchSidebarCountsThunk({
          userId,
          ...(roleType && { roleType }),
        })
      );
    }
  }, [user?.UserID, user?.Role, dispatch]); // add user?.Role to deps!

  useEffect(() => {
    if (donationFrom === "LANDINGPAGE" && donationStatus === "COMPLETED") {
      setModalIsOpen(false);
      dispatch(setDonationStatus(""));
      dispatch(setDonationFrom(""));
    }
  }, [donationStatus, donationFrom, dispatch]);

  const { inquiryOpen, inquiryFullOpen, actionType, inquiryNeedOpen } =
    useSelector((state) => state.searchBar);
  const lastWidthRef = useRef(window.innerWidth);
  const lastHeightRef = useRef(window.innerHeight);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const touchScreenDismissed = useRef(false);
  const footerlinks = isAboutUs || isPrivacyPolicy || isContactUs;
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleResize = useCallback(
    debounce(() => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const isHomePage =
        (location.pathname === "/" && location.hash === "") ||
        location.hash === "#/home";
      const iPadView = isIpad() || (screenWidth > 767 && screenWidth < 1200);
      if (
        !touchScreenDismissed.current &&
        (Math.abs(screenWidth - lastWidthRef.current) > 50 ||
          Math.abs(screenHeight - lastHeightRef.current) > 150)
      ) {
        setIsOpen(!(isHomePage && iPadView));
        lastWidthRef.current = screenWidth;
        lastHeightRef.current = screenHeight;
      }
    }, 300),
    [location.pathname, location.hash]
  );

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  useEffect(() => {
    touchScreenDismissed.current = false;
    const screenWidth = window.innerWidth;
    const isHomePage =
      (location.pathname === "/" && location.hash === "") ||
      location.hash === "#/home";
    const iPadView = isIpad() || (screenWidth > 767 && screenWidth < 1200);
    setIsOpen(!(isHomePage && iPadView));
  }, [location.pathname, location.hash]);

  const baseURl = process.env.REACT_APP_BASEURL;

  useEffect(() => {
    if (baseURl === "https://backend.mysikhcommunity.com/wedcom") {
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = "https://www.googletagmanager.com/gtag/js?id=G-4F4KKBK6HP";
      document.head.appendChild(script1);
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-4F4KKBK6HP');
      `;
      document.head.appendChild(script2);
    }
    fetchUserRole();
  }, []);

  useEffect(() => {
    if (myServices2.length === 0 || isAdmin) return;
    dispatch(setCustomerInitiatedServices(myServices2));
    if (myServices2.length > 0) {
      localStorage.setItem("USER_ROLE", "provider");
    } else {
      localStorage.setItem("USER_ROLE", "customer");
    }
  }, [myServices2]);

  const fetchUserRole = async () => {
    if (islogin && user && user?.RoleId !== 1 && !isFetching.current) {
      isFetching.current = true;
      const serviceParams = {
        pageId: 1,
        pageSize: 10,
        postStatus: 3,
        userId: user?.UserID,
      };
      Promise.all([dispatch(fetchMyservices(serviceParams))]).finally(() => {
        isFetching.current = false;
      });
    }
  };

  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 1024
  );

  const loginPopUpRestriction = () => {
    const timeoutId = setTimeout(() => {
      dispatch(setLoginPopUp(true));
    }, 120000);
    // return () => clearTimeout(timeoutId);
  };
  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth >= 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const threshold = 1 * windowHeight;
      setShowScrollTop(scrollPosition > threshold);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const hasFbclid = window.location.href.includes("fbclid");
  const isVendorPage = window.location.href.includes("vendordetails");
  const isEnquiry = inquiryOpen || inquiryNeedOpen || inquiryFullOpen;
  const hasShownRef = useRef(false);
  useEffect(() => {
    let timer;
    const canShowPopup =
      !islogin &&
      !hasShownRef.current &&
      isOpen &&
      !isTablet &&
      !isSignUp &&
      !isGurdwara &&
      !hasFbclid &&
      !isInvoicePage &&
      !isVendorPage &&
      !isResetPassword &&
      !footerlinks &&
      !isBookGurdwara &&
      !isNeedCreate &&
      !isEnlargeImageView &&
      !isEnquiry;
    if (canShowPopup) {
      timer = setTimeout(() => {
        hasShownRef.current = true;
        dispatch(setLoginPopUp(true));
      }, 300 * 1000);
    }
    return () => clearTimeout(timer);
  }, [
    islogin,
    isOpen,
    isTablet,
    isSignUp,
    isGurdwara,
    hasFbclid,
    isInvoicePage,
    isVendorPage,
    isResetPassword,
    footerlinks,
    isBookGurdwara,
    isNeedCreate,
    isEnlargeImageView,
    isEnquiry,
    dispatch,
  ]);
 
  return (
    <div style={{ overflow: "hidden" }}>
      {!isOpen && !isEnlargeImageView && (
        <div
          className="hide-listings"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: 99,
            cursor: "pointer",
            backgroundColor: "#de1c1c",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            textAlign: "center",
          }}
          onClick={() => {
            setIsOpen(true);
            touchScreenDismissed.current = true;
          }}
        >
          <h1 className="mb-4 fw-bold">Welcome to Gurdwara Services</h1>

          <div
            className="gurdwara-buttons"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: "60%",
              maxWidth: "300px",
            }}
          >
            <button
              className="gurdwara-btn donate-btn"
              onClick={handleDonate}
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#fff",
                color: "#de1c1c",
                fontWeight: "bold",
              }}
            >
              Donate
            </button>

            <button
              className="gurdwara-btn book-btn"
              onClick={toggleGurdwaraModal}
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#fff",
                color: "#de1c1c",
                fontWeight: "bold",
              }}
            >
              Book Gurdwara
            </button>

            <button
              className="gurdwara-btn ads-btn"
              onClick={handleViewAds}
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#fff",
                color: "#de1c1c",
                fontWeight: "bold",
              }}
            >
              View Community Ads
            </button>
          </div>
        </div>
      )}

      {/* ✅ NORMAL LAYOUT WHEN OPEN */}
      {isOpen && !isEnlargeImageView && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header setOpen={setOpen} isOpen={isOpen} />
          <ProgressBar textColor="#fff" barColor="#4caf50" />
          <div className="router-wrapper">
            <Routers open={isOpen} setOpen={setOpen} />
          </div>
        </div>
      )}

      {isEnlargeImageView && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Routers open={isOpen} setOpen={setOpen} />
        </div>
      )}

      {/* ✅ Popups */}
      <LoginPopUp
        isOpen={loginPopUp}
        closePopup={() => dispatch(setLoginPopUp(false))}
      />

      <DonateModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        Type="Footer"
        onClose={() => setModalIsOpen(false)}
        handleFormSubmit={true}
      />

      {modal && (
        <SelectGurdwaraModal
          isOpen={modal}
          toggleModal={() => setModal(false)}
          gurdwaraId={gurdwaraId}
          setGurdwaraId={setGurdwaraId}
          gurdwaraName={gurdwaraName}
          setGurdwaraName={setGurdwaraName}
        />
      )}

      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default Layout;
